import { ImageBroadcastWidgetWrapper } from '../../image-broadcast-widget/ImageBroadcastWidget';
import type { ImageBroadcastWidgetEntity } from '../../image-broadcast-widget/ImageBroadcastWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderImageBroadcastWidget(
  widget: ImageBroadcastWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return ({ onCreateImageBroadcastWidget }) => (
    <ImageBroadcastWidgetWrapper
      entity={widget}
      options={options}
      onCreateImageBroadcastWidget={onCreateImageBroadcastWidget}
    />
  );
}
